import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  Collapse,
} from '@mui/material';
import { Block as BlockIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useForbiddenError } from '../context/ForbiddenErrorContext';

export default function ForbiddenErrorDialog() {
  const { open, referenceId, hideForbiddenError } = useForbiddenError();
  const { t } = useTranslation(['auth', 'common']);
  const [showReferenceCode, setShowReferenceCode] = useState(false);

  const handleClose = () => {
    hideForbiddenError();
    setShowReferenceCode(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              backgroundColor: 'error.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <BlockIcon sx={{ color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight="bold">
              {t('auth:forbidden_error.title')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('auth:forbidden_error.subtitle')}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {t('auth:forbidden_error.message')}
        </Alert>

        <Typography variant="body2" color="text.secondary" paragraph>
          {t('auth:forbidden_error.contact_message')}
        </Typography>

        {referenceId && (
          <Box sx={{ mt: 2 }}>
            <Button
              size="small"
              onClick={() => setShowReferenceCode(!showReferenceCode)}
              endIcon={
                <ExpandMoreIcon
                  sx={{
                    transform: showReferenceCode ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s',
                  }}
                />
              }
              sx={{ mb: 1 }}
            >
              {t('auth:forbidden_error.show_reference')}
            </Button>
            <Collapse in={showReferenceCode}>
              <Box
                sx={{
                  p: 2,
                  backgroundColor: 'grey.100',
                  borderRadius: 1,
                }}
              >
                <Typography variant="caption" color="text.secondary" display="block">
                  {t('auth:forbidden_error.reference_label')}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: 'monospace',
                    wordBreak: 'break-all',
                    userSelect: 'all',
                  }}
                >
                  {referenceId}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button onClick={handleClose} variant="contained" color="primary">
          {t('common:buttons.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
